import { useContext } from "react"
import { LoaderContext } from "../providers/contexts/LoaderContext"

export const useLoader = () => {
    return useContext(LoaderContext);
}